/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 10:46:27
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
   /**
   * getEnumList
   * @description 分类管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCategoryEnumList(type) {
    let data = { type: type, is_default: 0 }
    return request.get(`/${BASE_URL}/category/enum`, data)
  },
  
  // 获取签约服务类型
  getQYtype(type){
	let data = { type: type }
	return request.get(`/${BASE_URL}/category/category_list`,data)
  },

  /**
   * getCategoryList
   * @description 分类管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCategoryList(data) {
    return request.post(`/${BASE_URL}/category/list`, data)
  },
  /**
   * saveCategory
   * @description 保存分类
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveCategory(data) {
    return request.post(`/${BASE_URL}/category/store`, data)
  },
  /**
   * getCategoryInfo
   * @description 获取分类详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCategoryInfo(id) {
    let data = {id:id}
    return request.post(`/${BASE_URL}/category/get_info`, data)
  },
  /**
   * deleteCategoryInfo
   * @description 删除分类详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteCategoryInfo(id) {
    let data = {id:id}
    return request.post(`/${BASE_URL}/category/delete`, data)
  },
  /**
   * @description 分类排序
   * @author YM
   * @date 2019-03-07
   * @param {*} ids
   * @returns
   */
  orderCategory(ids) {
    let data = {ids:ids}
    return request.post(`/${BASE_URL}/category/order`,data)
  }
}